module.exports = __webpack_public_path__ + "static/img/photo.7e284b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/photo.png
// module id = bmwG
// module chunks = 5